import React, { useEffect, useState } from "react";
import { APP_ROOT } from "Utils/EnvVars";
import useExternalScripts from "Utils/Hooks/useExternalScripts";
import useSessionStorage from "Utils/Hooks/useSessionStorage";
import OtpValidation from "./OtpValidation";
import Loading from "Components/Loading";

const DeviceVerification = ({ verified, noMobileError }) => {
  const { isLoaded } = useExternalScripts(false);
  const [session] = useSessionStorage("vip-patron-session");
  const [showOtpInput, setOtpInput] = useState(null);
  const [otpSession, setOtpSession] = useState({});

  useEffect(() => {
    const callVerifyDevice = async () => {
      try {
        const headers = {
          "session-id": session.sessionId,
          authorization: "PatronSession",
        };
        const response = await fetch(
          `${APP_ROOT}/api/patronsession/verifydevice`,
          {
            method: "GET",
            headers,
          },
        );
        if (response.status === 200) {
          const verDevResponse = await response.json();
          setOtpSession(verDevResponse);
          if (verDevResponse.showOtp) {
            setOtpInput(true);
          } else if (verDevResponse.hasError) {
            noMobileError(true);
          } else {
            verified(true);
          }
        }
      } catch (err) {
        console.log("Error sending OTP: ", err);
      }
    };
    if (isLoaded) {
      setTimeout(callVerifyDevice, 2000);
    }
  }, [isLoaded]);

  return session && showOtpInput ? (
    <OtpValidation otpSession={otpSession} verified={verified} />
  ) : (
    <Loading />
  );
};
export default DeviceVerification;
